/* eslint-disable no-unused-vars */
import { Modal } from "react-bootstrap";
import { StyledModal } from ".././../../auth/ForgotPassword/style.js";
import React, { useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { MutantApiService } from "../../../../services/MutantApiService";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Button } from "@material-ui/core";

import "react-datepicker/dist/react-datepicker.css";
import "./CostsForm.scss";

export const ConsolidationModal = ({ show, setShow }) => {
	const [date, setDate] = useState(new Date());
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);

	const handleDateChange = date => {
		setDate(date);
	};
	const api = new MutantApiService();

	const handleConsolidate = async () => {
		setLoading(true);
		try {
			await api.makeHttpRequest({
				method: "POST",
				url: "/prompt-billing-consolidate",
				data: {
					consolidationDate: moment(date).format("YYYY-MM-DD")
				}
			});

			Swal.fire({
				icon: "success",
				title: "Consolidação realizada com sucesso",
				showConfirmButton: false,
				timer: 1500
			});
		} catch (error) {
			console.error("error", error);
			setError(true);
			Swal.fire({
				icon: "error",
				title: "Erro ao consolidar",
				showConfirmButton: false,
				timer: 1500
			});
		}
		setLoading(false);
		setShow(false);
	};

	return (
		<StyledModal
			show={show}
			onHide={() => setShow(false)}
			style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				marginTop: "20%"
			}}
		>
			<Modal.Header closeButton>
				<Modal.Title>Consolidação manual</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography variant="h6"
							style={{
								marginBottom: "10px",
							}}
						>Data a ser consolidada</Typography>
						<DatePicker
							selected={date}
							onChange={handleDateChange}
							dateFormat="dd/MM/yyyy"
							className="custom-datepicker"
						/>
					</Grid>
				</Grid>
			</Modal.Body>
			<Modal.Footer
				style={{
					color: "white"
				}}
			>
				<Button
					onClick={handleConsolidate}
					variant="contained"
					color="primary"
					style={{
						backgroundColor: "#9036F7",
						color: "white"
					}}
				>
					Confirmar
				</Button>
			</Modal.Footer>
		</StyledModal>
	);
};
